/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "user_camera";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface PhotoCaptureResult {
}

export enum PhotoCaptureResult_Enum {
  CAPTURE_SUCCESSFUL = 0,
  CAPTURE_FAILED_LOW_SPACE = 1,
  CAPTURE_FAILED_CAMERA_ERROR = 2,
  CAPTURE_FAILED_FS_ERROR = 3,
  CAPTURE_FAILED_MODE_ERROR = 4,
  CAPTURE_FAILED_QUEUE_FULL = 5,
  CAPTURE_FAILED_UNSUPPORTED_FORMAT = 6,
  CAPTURE_IN_PROGRESS_EXPOSED = 8,
  READY_FOR_NEXT = 9,
  CAPTURE_DISABLED = 7,
  UNRECOGNIZED = -1,
}

export function photoCaptureResult_EnumFromJSON(object: any): PhotoCaptureResult_Enum {
  switch (object) {
    case 0:
    case "CAPTURE_SUCCESSFUL":
      return PhotoCaptureResult_Enum.CAPTURE_SUCCESSFUL;
    case 1:
    case "CAPTURE_FAILED_LOW_SPACE":
      return PhotoCaptureResult_Enum.CAPTURE_FAILED_LOW_SPACE;
    case 2:
    case "CAPTURE_FAILED_CAMERA_ERROR":
      return PhotoCaptureResult_Enum.CAPTURE_FAILED_CAMERA_ERROR;
    case 3:
    case "CAPTURE_FAILED_FS_ERROR":
      return PhotoCaptureResult_Enum.CAPTURE_FAILED_FS_ERROR;
    case 4:
    case "CAPTURE_FAILED_MODE_ERROR":
      return PhotoCaptureResult_Enum.CAPTURE_FAILED_MODE_ERROR;
    case 5:
    case "CAPTURE_FAILED_QUEUE_FULL":
      return PhotoCaptureResult_Enum.CAPTURE_FAILED_QUEUE_FULL;
    case 6:
    case "CAPTURE_FAILED_UNSUPPORTED_FORMAT":
      return PhotoCaptureResult_Enum.CAPTURE_FAILED_UNSUPPORTED_FORMAT;
    case 8:
    case "CAPTURE_IN_PROGRESS_EXPOSED":
      return PhotoCaptureResult_Enum.CAPTURE_IN_PROGRESS_EXPOSED;
    case 9:
    case "READY_FOR_NEXT":
      return PhotoCaptureResult_Enum.READY_FOR_NEXT;
    case 7:
    case "CAPTURE_DISABLED":
      return PhotoCaptureResult_Enum.CAPTURE_DISABLED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PhotoCaptureResult_Enum.UNRECOGNIZED;
  }
}

export function photoCaptureResult_EnumToJSON(object: PhotoCaptureResult_Enum): string {
  switch (object) {
    case PhotoCaptureResult_Enum.CAPTURE_SUCCESSFUL:
      return "CAPTURE_SUCCESSFUL";
    case PhotoCaptureResult_Enum.CAPTURE_FAILED_LOW_SPACE:
      return "CAPTURE_FAILED_LOW_SPACE";
    case PhotoCaptureResult_Enum.CAPTURE_FAILED_CAMERA_ERROR:
      return "CAPTURE_FAILED_CAMERA_ERROR";
    case PhotoCaptureResult_Enum.CAPTURE_FAILED_FS_ERROR:
      return "CAPTURE_FAILED_FS_ERROR";
    case PhotoCaptureResult_Enum.CAPTURE_FAILED_MODE_ERROR:
      return "CAPTURE_FAILED_MODE_ERROR";
    case PhotoCaptureResult_Enum.CAPTURE_FAILED_QUEUE_FULL:
      return "CAPTURE_FAILED_QUEUE_FULL";
    case PhotoCaptureResult_Enum.CAPTURE_FAILED_UNSUPPORTED_FORMAT:
      return "CAPTURE_FAILED_UNSUPPORTED_FORMAT";
    case PhotoCaptureResult_Enum.CAPTURE_IN_PROGRESS_EXPOSED:
      return "CAPTURE_IN_PROGRESS_EXPOSED";
    case PhotoCaptureResult_Enum.READY_FOR_NEXT:
      return "READY_FOR_NEXT";
    case PhotoCaptureResult_Enum.CAPTURE_DISABLED:
      return "CAPTURE_DISABLED";
    case PhotoCaptureResult_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBasePhotoCaptureResult(): PhotoCaptureResult {
  return {};
}

export const PhotoCaptureResult = {
  encode(_: PhotoCaptureResult, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PhotoCaptureResult {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePhotoCaptureResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): PhotoCaptureResult {
    return {};
  },

  toJSON(_: PhotoCaptureResult): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PhotoCaptureResult>, I>>(base?: I): PhotoCaptureResult {
    return PhotoCaptureResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PhotoCaptureResult>, I>>(_: I): PhotoCaptureResult {
    const message = createBasePhotoCaptureResult();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
